import { postRequest } from "../../../services/RestServices";
import * as urls from "../../api/C4S Decommission - Replacement/url";

export const getVehicleModel = async (data) => {
  try {
    return await postRequest(urls.VEHICLE_MODEL, data);
  } catch (err) {
    return err;
  }
};
